export default __webpack_public_path__ + "static/media/withdraw-reward-step4-option2.e5eee9e1.png";